module.exports = __webpack_public_path__ + "img/trend.1e32078c.png";